import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Publisher from './components/Publisher';
import Subscriber from './components/Subscriber';
import Home from './components/Home';
import LocalMode from './components/LocalMode';
import { ServerProvider } from './contexts/ServerContext';

function App() {
  return (
    <ServerProvider>
      <Router>
        <div className="min-h-screen bg-gray-100">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/publish" element={<Publisher />} />
            <Route path="/subscribe" element={<Subscriber />} />
            <Route path="/subscribe/:code" element={<Subscriber />} />
            <Route path="/local" element={<LocalMode />} />
          </Routes>
        </div>
      </Router>
    </ServerProvider>
  );
}

export default App; 